import querystring from 'querystring';
import get from 'lodash/get';
import recentSearches from '../utils/storage/recentSearches';

export const FETCH_SEARCH = 'FETCH_SEARCH';
export const FETCH_PREPOPULATE_SEARCH = 'FETCH_PREPOPULATE_SEARCH';
export const ADD_RECENT_SEARCH = 'ADD_RECENT_SEARCH';
export const GET_RECENT_SEARCHES = 'GET_RECENT_SEARCHES';
export const REMOVE_RECENT_SEARCH = 'REMOVE_RECENT_SEARCH';
export const CLEAR_RECENT_SEARCHES = 'CLEAR_RECENT_SEARCHES';

export const searchResultsContentId = 'searchResults';

const searchEndpoints = {
  [FETCH_SEARCH]: 'search',
  [FETCH_PREPOPULATE_SEARCH]: 'prepopulateSearch',
};

function fetchSearchEffect(
  type,
  query,
  attributes = '',
  disableLoadingState,
  itemToken,
) {
  const transform = (resp) => ({
    content: {
      containerItems: resp.data.items,
      itemsStyles: get(resp, 'data.metadata.styles', {}),
    },
  });
  const endpoint = searchEndpoints[type];
  const params = querystring.parse(attributes);

  if (itemToken) {
    params.itemToken = itemToken;
  }

  return {
    type,
    api: {
      endpoint: ['profile', endpoint],
      args: [query, params],
      transform,
    },
    meta: {
      contentId: searchResultsContentId,
      disableLoadingState,
      searchTerm: query,
    },
  };
}

export function performSearch({
  query,
  attributes,
  disableLoadingState,
  itemToken,
}) {
  return fetchSearchEffect(
    FETCH_SEARCH,
    query,
    attributes,
    disableLoadingState,
    itemToken,
  );
}

export function performPrepopulateSearch({
  query,
  attributes,
  disableLoadingState,
}) {
  return fetchSearchEffect(
    FETCH_PREPOPULATE_SEARCH,
    query,
    attributes,
    disableLoadingState,
  );
}

export function addRecentSearch(term) {
  return { type: ADD_RECENT_SEARCH, recentSearches: recentSearches.add(term) };
}

export function getRecentSearches() {
  return { type: GET_RECENT_SEARCHES, recentSearches: recentSearches.get() };
}

export function removeRecentSearch(termIndex) {
  return {
    type: REMOVE_RECENT_SEARCH,
    recentSearches: recentSearches.remove(termIndex),
  };
}

export function clearRecentSearches() {
  return {
    type: CLEAR_RECENT_SEARCHES,
    recentSearches: recentSearches.clear(),
  };
}
